import { createPluginSpec } from '#src/plugins/spec/types.js';
export function createAdminCrudActionWebConfig(config) {
    return config;
}
export function createAdminCrudActionWebImplementation() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions = new Map();
    return {
        registerActionWebConfig(action) {
            if (actions.has(action.name)) {
                throw new Error(`Admin CRUD action with name ${action.name} is already registered`);
            }
            actions.set(action.name, action);
        },
        getActionWebConfig(name, builtInActions = []) {
            const builtInAction = builtInActions.find((b) => b.name === name);
            if (builtInAction) {
                return builtInAction;
            }
            const action = actions.get(name);
            if (!action) {
                throw new Error(`Unable to find action with name ${name}`);
            }
            return action;
        },
        getActionWebConfigs(builtInActions = []) {
            return [...builtInActions, ...actions.values()];
        },
    };
}
/**
 * Spec for adding config component for plugin
 */
export const adminCrudActionWebSpec = createPluginSpec('core/admin-crud-action-web', { defaultInitializer: createAdminCrudActionWebImplementation });
//# sourceMappingURL=admin-crud-action-web-spec.js.map